import React from 'react';

const Wishlist = () => {
  const containerStyle = {
    fontFamily: 'sans-serif',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100vh',
    background: '#fff',
  };

  const headerContainerStyle = {
    position: 'relative',
    background: '#f5f5f5',
    borderBottom: '1px solid #ddd',
    padding: '12px 15px',
    textAlign: 'center',
  };

  const headerTitleStyle = {
    fontSize: '18px',
    fontWeight: 'bold',
    margin: 0,
  };

  const backButtonStyle = {
    position: 'absolute',
    left: '15px',
    top: '50%',
    transform: 'translateY(-50%)',
    fontSize: '18px',
    cursor: 'pointer',
  };

  const profilesSectionStyle = {
    padding: '10px',
    overflowY: 'auto',
    flex: 1,
  };

  const cardStyle = {
    background: '#fff',
    border: '1px solid #eee',
    borderRadius: '10px',
    padding: '15px',
    marginBottom: '15px',
    boxShadow: '0 0 4px rgba(0,0,0,0.05)',
  };

  const cardHeaderStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  };

  const badgeStyle = {
    backgroundColor: '#b6ded6',
    color: '#000',
    padding: '4px 10px',
    borderRadius: '10px',
    fontSize: '13px',
  };

  const viewButtonStyle = {
    marginTop: '15px',
    backgroundColor: '#e53935',
    color: 'white',
    padding: '10px',
    width: '100%',
    border: 'none',
    borderRadius: '30px',
    fontSize: '16px',
    cursor: 'pointer',
  };

  const bottomNavStyle = {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    padding: '8px 0',
    backgroundColor: '#f9f9f9',
    borderTop: '1px solid #ddd',
  };

  const navItemStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontSize: '12px',
  };

  const ProfileCard = () => (
    <div style={cardStyle}>
      <div style={cardHeaderStyle}>
        <strong>Naveen</strong>
        <span style={badgeStyle}>Excellent match</span>
      </div>
      <div style={{ marginTop: '10px' }}>
        <p><strong>Budget:</strong> <span>1.5L to 1.5cr</span></p>
        <p><strong>Buyer is looking in:</strong> <span>ABC Nagar</span></p>
        <p><strong>Last Active On:</strong> <span>21-05-2025</span></p>
        <p><strong>Properties Contacted:</strong> <span>05</span></p>
      </div>
      <button style={viewButtonStyle}>View Phone Number</button>
    </div>
  );

  return (
    <div style={containerStyle}>
      {/* Top Header */}
      <div style={headerContainerStyle}>
        <span style={backButtonStyle}>‹</span>
        <h2 style={headerTitleStyle}>Profile</h2>
      </div>

      {/* Profiles */}
      <div style={profilesSectionStyle}>
        <ProfileCard />
        <ProfileCard />
      </div>

      {/* Bottom Navigation */}
      <footer style={bottomNavStyle}>
        <div style={navItemStyle}>🏠<div>Home</div></div>
        <div style={navItemStyle}>✏️<div>Construction& Interiors</div></div>
        <div style={navItemStyle}>➕<div>Post</div></div>
        <div style={navItemStyle}>📅<div>Home Services</div></div>
        <div style={navItemStyle}>👤<div>Profile</div></div>
      </footer>
    </div>
  );
};

export default Wishlist;
